import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/WorkspaceApi/';
export const queryWorkspaceList = (data)=>{
  return getInterface.post(`${prefixUrl}queryWorkspaceList`, data);
}
export const publishWorkspace = (data)=>{
  return getInterface.post(`${prefixUrl}publishWorkspace`, data);
}
export const modifyWorkspace = (data)=>{
  return getInterface.post(`${prefixUrl}publishWorkspace`, data);
}

export const queryUserWorkspaceDataList = (data)=>{
  return getInterface.post(`${prefixUrl}queryUserWorkspaceDataList/${data}`, {});
}
// 新 - 删除工作空间数据
export const deleteUserWorkspaceGeoJsonData = (data)=>{
  return getInterface.post(`${prefixUrl}deleteUserWorkspaceGeoJsonData`, data);
}
// 按ID删除单个工作空间数据要素
export const deleteUserWorkspaceGeoJsonDataById = (id)=>{
  return getInterface.post(`${prefixUrl}deleteUserWorkspaceGeoJsonDataById/${id}`, {});
}